// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2r9K8","location":"Header_location__1KTAG"};